export default {
    tips: {
        credits: 'Take into account the credits you have remaining!',
        time: 'Hurry up! You have limited time to make choices!',
        items: 'Navigate through the items and click to see the details and select them.',
        charts: 'Use the data available to take the best maintenance decisions for your racing car.'
    }
}



// WEBPACK FOOTER //
// src/lang/locales/en/tour.js